import { render, staticRenderFns } from "./CourierAreaListMapping.vue?vue&type=template&id=673b18ee"
import script from "./CourierAreaListMapping.vue?vue&type=script&lang=js"
export * from "./CourierAreaListMapping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports